$(document).ready(function() {
  $(window).on('scroll', function() {
    var headerHeight = $('#SiteHeader').outerHeight();
    console.log('Header height:', headerHeight);
    // You can use the headerHeight variable as needed
  });
$('body').on('click', '.cart__remove .Cart_remove', async function (e) {
    e.preventDefault();
    e.stopPropagation(); // Ensure no event bubbling

    // Show the loader and reduce opacity of cart items
    $('#cart-loader').show();
    $('.cart__item').css('opacity', '0.6'); 

    // Get the line item key for the clicked product
    let lineItemKey = $(this).closest('.cart__item').attr('data-key');
    console.log('Removing item with lineItemKey:', lineItemKey);
    
    // Collect all items to be removed (initially just the clicked product)
    let itemsToRemove = [lineItemKey];  

    // Check if the clicked item is a main upsell product
    let cartItem = $(this).closest('.cart__item');
    let upsellMainId = cartItem.attr('customily-upsell-main-id');
    
    // If it's a Customily main upsell product, also remove related child products
    if (upsellMainId) {
        console.log('Will remove upsell products:', upsellMainId);
        $('.cart__item[customily-upsell-id="' + upsellMainId + '"]').each(function() {
            let childLineItemKey = $(this).attr('data-key');
            if (childLineItemKey) {
                itemsToRemove.push(childLineItemKey);  
            }
        });
    }

    // Track if all items are removed successfully
    let allItemsRemoved = true;

    // Iterate over each item to remove them one by one
    for (let id of itemsToRemove) {
        let formdata = {
            'id': id,
            'quantity': 0
        };

        try {
            let res = await fetch('/cart/change.js', {
                method: "POST",
                headers: {
                    'Content-Type': "application/json"
                },
                body: JSON.stringify(formdata)
            });

            if (res.ok) {
                console.log('Successfully removed item with lineItemKey:', id);

                // Add a small delay before updating the cart drawer
                await new Promise(resolve => setTimeout(resolve, 300));

                // Refresh the cart drawer immediately after each removal
                await refreshCartDrawer();
            } else {
                allItemsRemoved = false;
                const errorText = await res.text();
                console.error('Failed to remove item with lineItemKey:', id, errorText);
            }
        } catch (error) {
            allItemsRemoved = false;
            console.error('Network error while trying to remove item with lineItemKey:', id, error);
        }
    }

    if (!allItemsRemoved) {
        console.error("Failed to remove some items from the cart.");
    }

    // Hide the loader and reset opacity after the operation completes
    $('#cart-loader').hide();
    $('.cart__item').css('opacity', '1'); 

    // Ensure no page reload happens
    return false; 
});

// Function to refresh the cart drawer contents dynamically
async function refreshCartDrawer() {
    try {
        // Fetch the updated cart HTML using AJAX
        let res = await fetch('/cart', {
            method: "GET",
            headers: {
                'Content-Type': "text/html"
            }
        });

        if (res.ok) {
            let html = await res.text();
            let newCartContent = $(html).find('#CartDrawer').html();  // Extract the cart drawer HTML
            
            // Replace the current cart drawer content with the updated one
            $('#CartDrawer').html(newCartContent);
            
            // Re-initialize the cart drawer to bind events and update the UI
            var cartDrawer = new theme.CartDrawer();
            cartDrawer.init();

        } else {
            console.error('Error refreshing cart drawer.');
        }
    } catch (error) {
        console.error('Error fetching updated cart drawer content:', error);
    }
}
  
});
 document.addEventListener("DOMContentLoaded", () => {
  // Get the product title from the URL
  const urlParams = new URLSearchParams(window.location.search);
  let productTitle = urlParams.get("productTitle"); // Example: "The Outfielder"

  if (!productTitle) {
    console.error("No productTitle found in the URL.");
    return;
  }

  console.log(`Looking for product related to: ${productTitle}`);

  const scrollToProduct = () => {
    // Get all elements with data-product-title
    const productElements = document.querySelectorAll("[data-product-title]");
    
    let targetProduct = null;

    // Normalize search term: Remove "The" if present, add "Blank" before it
    const normalizedProductTitle = `Blank ${productTitle.replace(/\bThe\b/gi, "").trim()}`.toLowerCase();

    productElements.forEach((product) => {
      const productTitleAttribute = product.getAttribute("data-product-title").toLowerCase();

      // Match by checking if the product title contains the cleaned-up search term
      if (productTitleAttribute.includes(normalizedProductTitle)) {
        targetProduct = product;
      }
    });

    if (targetProduct) {
      console.log("Product found:", targetProduct);
      // Smooth scroll to the matched product block
      targetProduct.scrollIntoView({ behavior: "smooth", block: "center" });
    } else {
      console.log("Product not found, retrying...");
      setTimeout(scrollToProduct, 100); // Retry every 100ms if the product isn't found yet
    }
  };

  // Start the scrolling process
  scrollToProduct();
});